// Generated by Copilot- Start
import React from "react";
import DtvText from "../../../video-lab/dtv-text";

interface RsnTierLegalTextProps {
  tierNumber: number;
  rsnTierLegalText?: any;
  chnlSrc: string;
  position: "above-packages" | "after-heading" | "before-packages";
}

/**
 * RSN Tier Legal Text Component
 * Handles complex tier 1/2/3 legal text display logic for RSN channels
 *
 * Text placement rules:
 * - Tier 1: Shows AFTER "Available in these Packages" heading
 * - Tier 2/3: Shows AFTER table, BEFORE packages (large format) AND before package list (small format)
 */
const RsnTierLegalText: React.FC<RsnTierLegalTextProps> = ({ tierNumber, rsnTierLegalText, chnlSrc, position }) => {
  if (!rsnTierLegalText) {
    return null;
  }

  const isSatellite = chnlSrc === "dtvClup";
  const productKey = isSatellite ? "satellite" : "stream";

  // Tier 1 legal text - renders AFTER "Available in these Packages" heading
  const getTierOneLegalText = () => {
    if (tierNumber !== 1) {
      return "";
    }

    const tier1Text = rsnTierLegalText?.[0]?.[productKey]?.tier1 || "";

    // For stream, append linkToSatelliteText
    if (!isSatellite) {
      const linkText = rsnTierLegalText?.[0]?.linkToSatelliteText?.content || "";
      return tier1Text ? `${tier1Text} ${linkText}` : linkText;
    }

    return tier1Text;
  };

  // Tier 2/3 legal text - renders in multiple places
  const getTierLegalTextAbovePackages = () => {
    if (tierNumber === 1) {
      return "";
    }
    return rsnTierLegalText?.[0]?.[productKey]?.[`tier${tierNumber}`] || "";
  };

  // For tier 2/3 on stream, get linkToSatelliteText to append
  const getStreamTierAppendText = () => {
    if (isSatellite || tierNumber === 1) {
      return "";
    }
    return rsnTierLegalText?.[0]?.linkToSatelliteText?.content || "";
  };

  // Render based on position
  if (position === "after-heading" && tierNumber === 1) {
    const text = getTierOneLegalText();
    if (!text) {
      return null;
    }

    return (
      <DtvText
        component="p"
        content={text}
        variant="body1"
        sx={{
 fontSize: "14px !important",
mb: "16px"
}}
      />
    );
  }

  if (position === "above-packages" && tierNumber !== 1) {
    const text = getTierLegalTextAbovePackages();
    const appendText = getStreamTierAppendText();
    if (!text) {
      return null;
    }

    return (
      <DtvText
        component="p"
        content={`<sup style='line-height: 0; vertical-align: super;'>${tierNumber}</sup>${text}${appendText ? ` ${  appendText}` : ""}`}
        variant="body1"
        sx={{
          fontSize: "14px !important",
          mb: "16px"
        }}
      />
    );
  }

  if (position === "before-packages" && tierNumber !== 1) {
    const text = getTierLegalTextAbovePackages();
    if (!text) {
      return null;
    }

    return (
      <DtvText
        component="p"
        content={`<sup>${tierNumber}</sup> ${text}`}
        variant="body1"
        sx={{
 fontSize: "14px !important",
mb: "16px"
}}
      />
    );
  }

  return null;
};

export default React.memo(RsnTierLegalText);
// Generated by Copilot- End
